<template>
    <div style="min-width: 480px" class="write-content">
        <v-row>
            <v-col cols="6">
                <p>
                    <b>{{ marker.rack.description }}</b>
                </p>
                <p>
                    Venduto: <b>{{ calcTotals() | formatEuro }}</b>
                </p>
            </v-col>
            <v-col cols="6" class="text-right">
                <v-img
                    :src="marker.rack.image"
                    max-height="230"
                    max-width="130"
                    contain
                />
            </v-col>
        </v-row>
    </div>
</template>
<style scoped lang="scss">
.write-content {
    font-size: large;
}
</style>
<script>
import { marker } from "leaflet";

export default {
    name: "tolltip-product-list",
    props: {
        products: {
            type: Array,
            default: [],
        },
        marker: {
            type: Object,
            default: {},
        },
    },
    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    },
    methods: {
        calcTotals() {
            let totale = 0;
            this.products.forEach((product) => {
                totale += product.prezzo_tot;
            });
            return totale;
        },
    },
};
</script>
